import React, { useEffect } from 'react';
import Card from '../component/Card'
import { useProductContext } from '../providers/ProductProvider'
import { ClimbingBoxLoader, GridLoader, SyncLoader } from 'react-spinners'
const Home = () => {
const {data,loading} =useProductContext()
useEffect(()=>{
  window.scrollTo({
      top:0,
      behavior:"smooth"
  })
},[])
return (
<div>
{
      loading? (
        <div className=' container-fluid d-flex align-items-center justify-content-center '  style={{marginTop:"10%" ,marginBottom:"10%"}}> 
          <GridLoader color="#ADD8E6" /><b style={{color:"#ADD8E6"}}> Loading...</b>
        </div>
      ):(
      <div className='container'>
            
      <div className='row'>
        {
          data?.map((e)=>(
            <Card key={e._id} data={e}/>
          ))
        }
      </div>
    </div>
      )
    }
</div>

  )
}

export default Home
